import { render, staticRenderFns } from "./SafetyRecommendationsFilters.vue?vue&type=template&id=7f819a00"
import script from "./SafetyRecommendationsFilters.vue?vue&type=script&lang=js"
export * from "./SafetyRecommendationsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports